import React, { ReactNode } from 'react';

interface WrapperButton {
  component: React.ReactNode;
}

interface ComponentWrapperProps {
  icon?: ReactNode;
  title: ReactNode; // Changed from string to ReactNode for more flexibility
  buttonOne?: ReactNode;
  buttonsTwo?: WrapperButton[];
  children: ReactNode;
  className?: string;
}

const ComponentWrapper = ({
  icon,
  title,
  buttonOne,
  buttonsTwo,
  children,
  className = '',
}: ComponentWrapperProps) => {
  return (
    <div className="flex flex-col w-full gap-5 mt-0 md:mt-8 px-2">
      <div
        className={`w-full p-4 sm:p-8 md:p-10 bg-transparent sm:bg-white rounded-3xl ${className}`}
      >
        <div className="flex flex-row items-center justify-between mb-6 sm:mb-10">
          {/* Title and Icon - Reduced size on mobile */}
          <div className="flex items-center gap-2 sm:gap-3 flex-1">
            {icon && <span className="text-2xl sm:text-3xl md:text-4xl">{icon}</span>}
            <div className="font-semibold text-xl md:text-3xl flex-1">{title}</div>
          </div>

          {/* Buttons Container - Single row flow */}
          <div className="flex items-center">
            {/* Primary Button */}
            {buttonOne}

            {buttonsTwo && buttonsTwo.length > 0 && (
              <div className="hidden sm:flex sm:flex-row items-center gap-2 sm:gap-3">
                {buttonsTwo.map((button, index) => (
                  <div key={index}>{button.component}</div>
                ))}
              </div>
            )}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default ComponentWrapper;
